// extracted by mini-css-extract-plugin
export default {"title":"Error404_title__wx3Ud","text":"Error404_text__EYZDq","link":"Error404_link__mNQ5r","box":"Error404_box__oUvaX","image":"Error404_image__mzSig"};